import { Injectable, inject } from '@angular/core';

import { UrlConstants } from '../config/urlConstants';
import { DataService } from './data.service';
import { QdApiService } from './qd.service';

@Injectable({
    providedIn: 'root',
})
export class StakeAmountService {
    private dataService = inject(DataService);
    private apiService = inject(QdApiService);

    data: any = {};
    _isFullStakeAmountNotMet: boolean = false;

    constructor() {
        this.intialize();
    }

    intialize() {
        this.data.stake = 0.0;
        this.data.estimatedReturn = 0.0;
        this.data.amountRequiredToMeetStake = 0.0;
        this.data.currency = '';
        this.data.initialized = false;
        this.data.priceChanged = false;

        this.addEventListener();
    }

    isStakeAmountServiceInitialized() {
        return this.data.initialized;
    }

    set stake(stake) {
        this.data.stake = stake;
    }

    get stake() {
        return this.data.stake;
    }

    set currency(currency) {
        this.data.currency = currency;
    }

    get currency() {
        return this.data.currency;
    }

    get estimatedReturn() {
        return this.data.estimatedReturn;
    }

    retrieveAmountRequiredToMeetStake(callback: any) {
        if (this.data.stake === 0) {
            if (typeof callback === 'function') {
                callback();
            }
            return;
        }

        if (
            this.dataService.sessionInfo.estimatedReturn &&
            !isNaN(this.dataService.sessionInfo.estimatedReturn) &&
            this.dataService.sessionInfo.estimatedReturn != 0
        ) {
            this.data.estimatedReturn = parseFloat(this.dataService.sessionInfo.estimatedReturn).toFixed(2);
        }

        const queryString = '?stake=' + this.data.stake;
        this.apiService.get(UrlConstants.STAKE_AMOUNT_URI + queryString).subscribe((response) => {
            if (response.data) {
                this.data.currency = response.data.currencyCode;
                this.data.amountRequiredToMeetStake = parseFloat(response.data.value).toFixed(2);
                this.data.initialized = true;
            }

            if (typeof callback === 'function') {
                callback(this.data.amountRequiredToMeetStake);
            }
        });
    }

    addEventListener() {
        window.addEventListener('message', (event) => {
            if (event.origin === window.location.origin) {
                return;
            }
            const messageData = event.data;
            if (messageData.eventName == 'StakeChange' || messageData.eventName == 'PriceChange') {
                if (messageData.eventName == 'PriceChange') {
                    this.data.priceChanged = true;
                }

                this.data.stake = messageData.eventData.stake / 100;
                if (
                    messageData.eventData.estimatedReturn &&
                    !isNaN(messageData.eventData.estimatedReturn) &&
                    messageData.eventData.estimatedReturn != 0
                ) {
                    this.data.estimatedReturn = parseFloat((messageData.eventData.estimatedReturn / 100).toString()).toFixed(2);
                }
                const queryString = '?stake=' + this.data.stake;
                this.apiService.get(UrlConstants.STAKE_AMOUNT_URI + queryString).subscribe((response) => {
                    if (response.data) {
                        this.data.currency = response.data.currencyCode;
                        this.data.amountRequiredToMeetStake = parseFloat(response.data.value).toFixed(2);
                    }
                });
            }
        });
    }

    getAmountToBePopulated(txnCurrency: any, conversionRates: any, selectedOption: any) {
        if (this.data.amountRequiredToMeetStake === 0 || conversionRates) {
            return '';
        }

        if (txnCurrency) {
            const accountCurrency = selectedOption.paymentMethodInfo.minDepositLimit.currencyCode;
            const key = txnCurrency.toUpperCase() + '_TO_' + accountCurrency.toUpperCase();
            let exchangeRate = 1.0;
            exchangeRate = conversionRates[key];
            return parseFloat((this.data.amountRequiredToMeetStake / exchangeRate).toString()).toFixed(2);
        }

        return parseFloat(this.data.amountRequiredToMeetStake).toFixed(2);
    }

    get isFullStakeAmountNotMet() {
        return this._isFullStakeAmountNotMet;
    }

    set isFullStakeAmountNotMet(_isfullStakeAmountNotMet) {
        this._isFullStakeAmountNotMet = _isfullStakeAmountNotMet;
    }
}
